import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";

export const addUpdateInstaller = async (payload) => {
  try {
    return await postRequest(urls.ADD_UPDATE_INSTALLER, payload);
  } catch (err) {
    return err?.response;
  }
};
